// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"298":"016f7252","588":"0ae8681a"}[chunkId] + ".chunk.css";
};